export default __webpack_public_path__ + "static/success-rio-ace02d37da1f6988ae3fde8b58833bbe.png";